// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --dev` replaces `environment.ts` with `environment.dev.ts`.
// The list of file replacements can be found in `angular.json`.

//this is for the Local Environment.
export const environment = {
    production: true,
    Build_Timestamp: '11/03/2026 08:59:01 AM CST'
};
